import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


export const baseUrl = import.meta.env.VITE_AUTH_API_URL || "https://api.nexalifecare.com/api/v1/";


export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: "user/login/",
                method: "POST",
                body: data
            })
        }),
    })
});

export const {
    useLoginMutation,
} = authApi;
